import { getWorkerUrl } from '@hive/env/worker';
import { CodeLayoutHandlerExtension } from '@blocksuite/hive/blocks/code';
import { ImageLayoutHandlerExtension } from '@blocksuite/hive/blocks/image';
import { ListLayoutHandlerExtension } from '@blocksuite/hive/blocks/list';
import { NoteLayoutHandlerExtension } from '@blocksuite/hive/blocks/note';
import { ParagraphLayoutHandlerExtension } from '@blocksuite/hive/blocks/paragraph';
import {
  TurboRendererConfigFactory,
  ViewportTurboRendererExtension,
} from '@blocksuite/hive/gfx/turbo-renderer';

function createPainterWorker() {
  const worker = new Worker(getWorkerUrl('turbo-painter'));
  return worker;
}

export function patchTurboRendererExtension() {
  return [
    ParagraphLayoutHandlerExtension,
    ListLayoutHandlerExtension,
    NoteLayoutHandlerExtension,
    CodeLayoutHandlerExtension,
    ImageLayoutHandlerExtension,
    TurboRendererConfigFactory({
      options: {
        zoomThreshold: 1,
        debounceTime: 1000,
      },
      painterWorkerEntry: createPainterWorker,
    }),
    ViewportTurboRendererExtension,
  ];
}
